module.exports = __webpack_public_path__ + "img/face5.37e1de69.png";